import CodeMirror from 'codemirror';
import '../../../../node_modules/codemirror/mode/javascript/javascript';
import '../../../../node_modules/codemirror/addon/mode/overlay';
import {
    getColorClassByText, resetUsedColors
} from '../mini/getColorByText';
import {
    commonJsKeywords,
    highlightedFunctions,
    highlightedObjects,
    highlightedObjectWithDot,
} from '../../const/keywords';

import globalEvents from '../../const/globalEvents';


var commentRegex = /\/\//;
var todoRegex = /TODO:.*$/;
var urlRegex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%,\?\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_,\?]*)#?(?:[\.\-\!\/\\\w,]*))?)/;

const stringPattern = /(\$\(~\s([puv])?:?|\$\()/;

var allObj = highlightedObjects.join('|');
var allObjWithDots = highlightedObjectWithDot.join('|');
var allFn = highlightedFunctions.join('|');
var allCommonJsKeywords = commonJsKeywords.join('|');
var alanWordsRegex = new RegExp(`\\b=*(${allFn})(?=\\s*\\()`);
var alanObjRegex = new RegExp(`\\b=*(${allObj})\\b(?=\W)`);
var alanObjWithDotsRegex = new RegExp(`\\b=*${allObjWithDots}\\b`);
var allCommonJsKeywordsRegex = new RegExp(`\\b=*${allCommonJsKeywords}\\b`);

const stringClasses = ['string', 'string-2']


CodeMirror.defineMode("alanKeywords", function (config, parserConfig) {
    var alanKeywordsOverlay = {
        startState: function () {
            resetUsedColors();
            return {
                isMultiComment: false,
                isComment: false,
                isSlot: false,
            };
        },
        token: function (stream, state) {
            if (stream.pos === 0 && state.isComment) {
                state.isComment = false;
            }
            if (stream.match(todoRegex)) { //exclude comments
                stream.next();
                return 'todo';
            } else if (stream.match(new RegExp(/:\/\//))) { //exclude :// part of urls
                stream.next();
                return null;
            } else if (stream.match(commentRegex)) { //exclude comments
                state.isComment = true;
                // stream.next();
                return 'alan-single-line-comment';
            } else if (stream.match('/*')) {//exclude multiline comments
                state.isMultiComment = true;
                // stream.next("*/");
                return null;
            } else if (stream.match('*/')) {
                state.isMultiComment = false;
                return null;
            } else if (stream.match(new RegExp(`(\\.|_(${allFn}))`))) {//exclude p.print statement from highlighting
                stream.next('');
                return null;
            } else {
                if (state.isSlot) {
                    const match = stream.match(/([puv])?:?([a-zA-Z0-9_]+)/);
                    state.isSlot = false;
                    return match ? getColorClassByText(match[2]) : null;
                } else if (!state.isMultiComment) {
                    if (!state.isComment) {
                        if (
                            !stringClasses.includes(stream.lineOracle.state.baseCur) &&
                            (
                                (stream.match(allCommonJsKeywordsRegex) && (stream.lineOracle.state.baseCur === 'variable'))
                            )
                        ) {
                            return 'keyword';
                        } else if (
                            !stringClasses.includes(stream.lineOracle.state.baseCur) &&
                            (
                                (stream.match(alanObjWithDotsRegex) && (stream.lineOracle.state.baseCur === 'variable')) ||
                                (stream.match(alanWordsRegex) && (stream.lineOracle.state.baseCur === 'variable')) ||
                                (stream.match(alanObjRegex) && stream.lineOracle.state.baseCur === 'variable')
                            )
                        ) {
                            return 'alan-keyword';
                        } else if (stringClasses.includes(stream.lineOracle.state.baseCur) && stream.match(stringPattern)) {
                            state.isSlot = true;
                            return null;
                        } else {
                            stream.next();
                            return null;
                        }
                    } else if (state.isComment) {
                        if (stream.match(urlRegex)) {
                            return "alan-single-line-comment-url";
                        } else {
                            stream.next();
                            return 'alan-single-line-comment';
                        }
                    } else {
                        stream.next();
                        return null;
                    }
                } else if (state.isMultiComment) {
                    if (stream.match(urlRegex)) {
                        return "alan-url";
                    } else {
                        stream.next();
                        return null;
                    }
                } else {
                    stream.next();
                    return null;
                }
            }
        }
    };
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "javascript"), alanKeywordsOverlay);
});

CodeMirror.defineInitHook((cm) => {
    cm.display.wrapper.addEventListener('mousedown', (e) => {
        const el = e.target;
        if (e.ctrlKey || e.metaKey) {
            let parentEl = el.parentNode;
            const initialParent = parentEl;
            if (!parentEl) {
                return;
            }
            while (!parentEl.classList?.contains('CodeMirror-line')) {
                parentEl = parentEl.parentNode;
                if (!parentEl) {
                    return;
                }
            }
            const isProperty = el.classList.contains('cm-property');
            const isDefinition = el.classList.contains('cm-def');
            const isVariable = el.classList.contains('cm-variable-2')
                || el.classList.contains('cm-variable');
            const siblings = [...initialParent.childNodes];
            const index = siblings.indexOf(el);
            const prev = siblings[index - 1];
            const next = siblings[index + 1];
            const shadowVariable = isProperty
                && (!prev || (prev.textContent && prev.textContent[prev.textContent.length - 1] !== '.'))
                && (!next || (next.textContent && next.textContent[0] !== ':'));

            const cursor = cm.getCursor();
            const clickedLine = cursor.line + 1;

            if (isDefinition || isVariable || shadowVariable) {
                CodeMirror.signal(cm, 'onDefClick', {
                    isDefinition,
                    isVariable: isVariable || shadowVariable,
                    name: `${el.innerText}.${clickedLine}`,
                });
            }
            if (el.classList.contains('cm-alan-url')) {
                window.open(el.innerText, '_blank');
            }
            if (el.classList.contains('cm-alan-single-line-comment-url')) {
                window.open(el.innerText, '_blank');
            }
        }
    });

    const onVariableHoverListenerDebounced = _.debounce((e) => {
        const el = e.target;
        const isVariable = el.classList.contains('cm-variable-2')
            || el.classList.contains('cm-variable');

        if (isVariable) {
            window.dispatchEvent(new CustomEvent(globalEvents.CM_ON_VARIABLE_MOUSE_IN,
                {
                    detail: {
                        name: el.innerText,
                        x: e.layerX,
                        y: e.clientY,
                    }
                }
            ));
        } else {
            window.dispatchEvent(new CustomEvent(globalEvents.CM_ON_VARIABLE_MOUSE_OUT));
        }
    }, 500);

    cm.display.wrapper.addEventListener('mousemove', onVariableHoverListenerDebounced);
});
